export default __webpack_public_path__ + "static/media/bg3.62811587.jpg";